import _get from 'lodash/get'
import _isObject from 'lodash/isObject'
import _parseInt from 'lodash/parseInt'
import _toString from 'lodash/toString'

/**
 * CONTENT TYPES
 *
 * Using the following properties/values:
 *    type: product_video, product_series
 *    product_type: single, episode, episodic, segment, segmented
 *    display_type: normal, yoga, fitness
 *    admin_category.tid: 118946 (Meditation), 0 (null)
 *
 * NOTE: Meditation has NEVER been a real attribute in the CMS.  Using admin_category is
 *       completely WRONG!  This needs to be refactored for meditation to be a display type
 *       concept in the CMS, if truly desired as a business concept.
 *
 * Does not impact the design.
 *    production_status
 *
 * Determine the following nid type using the above:
 *
 * video = (4891): product_video, single, normal, 0
 * videoYoga = (106866): product_video, single, yoga, 0
 * videoFitness = (82066): product_video, single, fitness, 0
 * videoMeditation = (82661): product_video, single, yoga, meditation (tid===118946)
 *
 * episode = (102896): product_video, episode, normal, 0
 * episodeYoga = (108886): product_video, episode, yoga, 0
 * episodeFitness = (): product_video, episode, fitness, 0
 * episodeMeditation = (94171): product_video, episode, yoga, meditation (tid===118946)
 *
 * segment
 * segmentYoga = (): product_video, segment, yoga, 0
 * segmentFitness = (27693): product_video, segment, fitness, 0
 *
 * series = (102891): product_series, episodic, normal, 0
 * seriesYoga = (108881): product_series, episodic, yoga, 0
 * seriesFitness = (27692): product_series, segmented, fitness, 0
 * seriesMeditation = (94166): product_series, episodic, yoga, meditation (tid===118946)
 *
 * Variations:
 * `for t in video-{single,episode,segment}-{normal,yoga,fitness} series-{episodic,segmented}-
 * {normal,yoga,fitness}; do echo $t; done`
 *  video-single-normal
 *  video-single-yoga
 *  video-single-fitness
 * #video-single-meditation
 *  video-episode-normal
 *  video-episode-yoga
 *  video-episode-fitness
 * #video-episode-meditation
 *  video-segment-normal
 *  video-segment-yoga
 *  video-segment-fitness
 * #video-segment-meditation
 *  series-episodic-normal
 *  series-episodic-yoga
 *  series-episodic-fitness (doesn't exist)
 * #series-episodic-meditation
 *  series-segmented-normal
 *  series-segmented-yoga
 *  series-segmented-fitness
 * #series-segmented-meditation
 *
 * #Please note, meditation is part of yoga! admin category === 118946 tid
 *
 * We are treating episode === segment and series === segmented for design purposes.
 *
 */

// Content Types
export const TYPE_CONTENT_HOME = 'home'
export const TYPE_CONTENT_CATEGORY_SEEKING_TRUTH = 'seekingTruth'
export const TYPE_CONTENT_CATEGORY_TRANSFORMATION = 'transformation'
export const TYPE_CONTENT_CATEGORY_YOGA = 'yoga'
export const TYPE_CONTENT_CATEGORY_FILMS_DOCS = 'filmsDocs'
export const TYPE_CONTENT_CATEGORY_CENTERS = 'centers'
export const TYPE_CONTENT_SUBCATEGORY = 'subcategory'
export const TYPE_CONTENT_VIDEO = 'video'
export const TYPE_CONTENT_VIDEO_YOGA = 'videoYoga'
export const TYPE_CONTENT_VIDEO_FITNESS = 'videoFitness'
export const TYPE_CONTENT_VIDEO_MEDITATION = 'videoMeditation'
export const TYPE_CONTENT_EPISODE = 'episode'
export const TYPE_CONTENT_EPISODE_YOGA = 'episodeYoga'
export const TYPE_CONTENT_EPISODE_FITNESS = 'episodeFitness'
export const TYPE_CONTENT_EPISODE_MEDITATION = 'episodeMeditation'
export const TYPE_CONTENT_EPISODE_GUIDE = 'episodeGuide'
export const TYPE_CONTENT_SEGMENT = 'segment'
export const TYPE_CONTENT_SEGMENT_YOGA = 'segmentYoga'
export const TYPE_CONTENT_SEGMENT_FITNESS = 'segmentFitness'
export const TYPE_CONTENT_SEGMENT_MEDITATION = 'segmentMeditation'
export const TYPE_CONTENT_SERIES = 'series'
export const TYPE_CONTENT_SERIES_YOGA = 'seriesYoga'
export const TYPE_CONTENT_SERIES_FITNESS = 'seriesFitness'
export const TYPE_CONTENT_SERIES_MEDITATION = 'seriesMeditation'
export const TYPE_CONTENT_SERIES_GUIDE = 'seriesGuide'
export const TYPE_CONTENT_SERIES_LINK = 'seriesLink'
export const TYPE_CONTENT_SEGMENTED = 'series'
export const TYPE_CONTENT_SEGMENTED_YOGA = 'seriesYoga'
export const TYPE_CONTENT_SEGMENTED_FITNESS = 'seriesFitness'
export const TYPE_CONTENT_SEGMENTED_MEDITATION = 'seriesMeditation'
export const TYPE_CONTENT_ARTICLE = 'article'
export const TYPE_CONTENT_UNKNOWN = 'unknown'
export const TYPE_CONTENT_PEOPLE = 'people'
export const TYPE_CONTENT_PERSON = 'person'
export const TYPE_CONTENT_TOPIC = 'topic'
export const TYPE_CONTENT_TAG = 'tag'
export const TYPE_CONTENT_PRODUCT = 'product'
export const TYPE_CONTENT_PROMOTION = 'promotion'
export const CONTENT_TYPE_COURSE = 'course'
export const CONTENT_TYPE_COURSE_MODULE = 'course-module'

// Product Types
export const TYPE_PRODUCT_SINGLE = 'single'
export const TYPE_PRODUCT_EPISODE = 'episode'
export const TYPE_PRODUCT_EPISODIC = 'episodic'
export const TYPE_PRODUCT_SEGMENT = 'segment'
export const TYPE_PRODUCT_SEGMENTED = 'segmented'
export const TYPE_PRODUCT_NONE = 'none'
export const TYPE_PRODUCT_UNKNOWN = 'unknown'

// Display Types
export const TYPE_DISPLAY_NORMAL = 'normal'
export const TYPE_DISPLAY_YOGA = 'yoga'
export const TYPE_DISPLAY_FITNESS = 'fitness'
export const TYPE_DISPLAY_EVENT = 'event'
export const TYPE_DISPLAY_GUIDE = 'guide'
export const TYPE_DISPLAY_RECIPE = 'recipe'

// Content Subtypes
export const SUBTYPE_CONTENT_NORMAL = 'normal'
export const SUBTYPE_CONTENT_YOGA = 'yoga'
export const SUBTYPE_CONTENT_FITNESS = 'fitness'
export const SUBTYPE_CONTENT_MEDITATION = 'meditation'
export const SUBTYPE_CONTENT_EVENT = 'event'
export const SUBTYPE_CONTENT_GUIDE = 'guide'
export const SUBTYPE_CONTENT_RECIPE = 'recipe'

// Tag Types
export const TYPE_TAG_GENRE = 'genres'
export const TYPE_TAG_YOGA_DURATION = 'yoga-duration'
export const TYPE_TAG_YOGA_STYLE = 'yoga-style'
export const TYPE_TAG_YOGA_LEVEL = 'yoga-level'
export const TYPE_TAG_YOGA_FOCUS = 'yoga-focus'
export const TYPE_TAG_YOGA_TEACHER = 'yoga-teacher'
export const TYPE_TAG_FITNESS_DURATION = 'fitness-duration'
export const TYPE_TAG_FITNESS_STYLE = 'fitness-style'
export const TYPE_TAG_FITNESS_LEVEL = 'fitness-level'
export const TYPE_TAG_FITNESS_FOCUS = 'fitness-focus'
export const TYPE_TAG_FITNESS_INSTRUCTOR = 'fitness-instructor'
export const TYPE_TAG_MEDITATION_DURATION = 'meditation-duration'
export const TYPE_TAG_MEDITATION_STYLE = 'meditation-style'
export const TYPE_TAG_MEDITATION_LEVEL = 'meditation-level'
export const TYPE_TAG_MEDITATION_FOCUS = 'meditation-focus'
export const TYPE_TAG_CENTERS = 'centers'
export const TYPE_TAG_RAINBOW_CATEGORY = 'rainbow-category'

// CMS Types
export const TYPE_CMS_NODE = 'node'
export const TYPE_CMS_TERM = 'term'

// Placeholder Types
export const TYPE_PLACEHOLDER = 'placeholder'

// Studio types
export const TYPE_STUDIO_GAIA = 'Gaia'

// video, series or product
export function getRealContentType (nodeData) {
  const type = _get(nodeData, 'type', '')
  let contentType
  if (_isObject(type)) {
    contentType = _get(type, 'content', '')
  } else {
    contentType = _toString(type).replace('product_', '')
  }

  switch (contentType) {
    case 'series':
      return TYPE_CONTENT_SERIES
    case 'video':
      return TYPE_CONTENT_VIDEO
    case 'product':
      return TYPE_CONTENT_PRODUCT
    case 'person':
      return TYPE_CONTENT_PERSON
    case 'tag':
      return TYPE_CONTENT_TAG
    default:
      return TYPE_CONTENT_UNKNOWN
  }
}

// episode, segment or single (for videos)
// episodic of segmented (for series)
export function getRealProductType (nodeData) {
  const contentType = getRealContentType(nodeData)

  const type = _get(nodeData, 'type', '')
  let productType
  if (_isObject(type)) {
    productType = _get(type, 'product', '')
  } else {
    productType = _get(nodeData, 'product_type', '')
  }

  if (contentType === 'series') {
    switch (productType) {
      case 'segmented':
        return TYPE_PRODUCT_SEGMENTED
      case 'episodic':
      default:
        return TYPE_PRODUCT_EPISODIC
    }
  } else {
    switch (productType) {
      case 'episode':
        return TYPE_PRODUCT_EPISODE
      case 'segment':
        return TYPE_PRODUCT_SEGMENT
      case 'single':
      default:
        return TYPE_PRODUCT_SINGLE
    }
  }
}

// yoga, fitness or normal
export function getRealDisplayType (nodeData) {
  const type = _get(nodeData, 'type', '')
  let displayType
  if (_isObject(type)) {
    displayType = _get(type, 'display', '')
  } else {
    displayType = _get(nodeData, 'display_type', '')
  }

  switch (displayType) {
    case 'yoga':
      return TYPE_DISPLAY_YOGA
    case 'fitness':
      return TYPE_DISPLAY_FITNESS
    case 'guide':
      return TYPE_DISPLAY_GUIDE
    default:
      return TYPE_DISPLAY_NORMAL
  }
}

// The three "real" type functions are all that should exist.
// These others are legacy mess that should be cleaned up.

export function getImpressionType (data) {
  return getRealContentType(data)
}

export function getContentType (cmsType, data) {
  const type = _get(data, 'type', '')
  let rawType
  if (_isObject(type)) {
    rawType = [
      _get(type, 'content', ''),
      _get(type, 'product', ''),
      _get(type, 'display') || TYPE_DISPLAY_NORMAL,
    ]
  } else {
    rawType = [
      _toString(type).replace('product_', ''),
      _get(data, 'product_type', ''),
      _get(data, 'display_type') || TYPE_DISPLAY_NORMAL,
    ]
  }
  switch (cmsType) {
    case TYPE_CMS_NODE: {
      const isMeditation = _parseInt(_get(data, 'admin_category.tid', -1)) === 118946
      switch (rawType.join('-')) {
        case 'video-single-normal':
          return TYPE_CONTENT_VIDEO
        case 'video-single-yoga':
          return isMeditation
            ? TYPE_CONTENT_VIDEO_MEDITATION
            : TYPE_CONTENT_VIDEO_YOGA
        case 'video-single-fitness':
          return TYPE_CONTENT_VIDEO_FITNESS
        case 'video-episode-normal':
        case 'video-episode-event':
          return TYPE_CONTENT_EPISODE
        case 'video-episode-yoga':
          return isMeditation
            ? TYPE_CONTENT_EPISODE_MEDITATION
            : TYPE_CONTENT_EPISODE_YOGA
        case 'video-episode-fitness':
          return TYPE_CONTENT_EPISODE_FITNESS
        case 'video-episode-guide':
          return TYPE_CONTENT_EPISODE_GUIDE
        case 'video-segment-normal':
          return TYPE_CONTENT_SEGMENT
        case 'video-segment-yoga':
          return isMeditation
            ? TYPE_CONTENT_SEGMENT_MEDITATION
            : TYPE_CONTENT_SEGMENT_YOGA
        case 'video-segment-fitness':
          return TYPE_CONTENT_SEGMENT_FITNESS
        case 'series-episodic-normal':
        case 'series-episodic-event':
          return TYPE_CONTENT_SERIES
        case 'series-episodic-yoga':
          return isMeditation
            ? TYPE_CONTENT_SERIES_MEDITATION
            : TYPE_CONTENT_SERIES_YOGA
        case 'series-episodic-fitness':
          return TYPE_CONTENT_SERIES_FITNESS
        case 'series-episodic-guide':
          return TYPE_CONTENT_SERIES_GUIDE
        case 'series-segmented-normal':
          return TYPE_CONTENT_SEGMENTED
        case 'series-segmented-yoga':
          return isMeditation
            ? TYPE_CONTENT_SEGMENTED_MEDITATION
            : TYPE_CONTENT_SEGMENTED_YOGA
        case 'series-segmented-fitness':
          return TYPE_CONTENT_SEGMENTED_FITNESS
        default:
          return TYPE_CONTENT_UNKNOWN
      }
    }
    case TYPE_CMS_TERM:
      return TYPE_CONTENT_SUBCATEGORY
    default:
      return TYPE_CONTENT_UNKNOWN
  }
}

export function getProductType (cmsType, data) {
  switch (cmsType) {
    case TYPE_CMS_NODE:
      switch (_get(data, 'product_type')) {
        case 'single':
          return TYPE_PRODUCT_SINGLE
        case 'episode':
          return TYPE_PRODUCT_EPISODE
        case 'episodic':
          return TYPE_PRODUCT_EPISODIC
        case 'segment':
          return TYPE_PRODUCT_SEGMENT
        case 'segmented':
          return TYPE_PRODUCT_SEGMENTED
        default:
          return TYPE_PRODUCT_NONE
      }
    case TYPE_CMS_TERM:
      return TYPE_PRODUCT_NONE
    default:
      return TYPE_PRODUCT_UNKNOWN
  }
}

export function getStudio (data) {
  return _get(data, 'fields.studio[0].value', null)
}

export function isTypeVideo (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO:
      return true
    default:
      return false
  }
}

export function isTypeYogaFitnessVideo (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO_YOGA:
    case TYPE_CONTENT_VIDEO_FITNESS:
    case TYPE_CONTENT_VIDEO_MEDITATION:
      return true
    default:
      return false
  }
}

export function isTypeYogaVideo (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO_YOGA:
      return true
    default:
      return false
  }
}

export function isTypeMeditationVideo (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO_MEDITATION:
      return true
    default:
      return false
  }
}

export function isTypeFitnessVideo (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO_FITNESS:
      return true
    default:
      return false
  }
}

export function isTypeVideoAll (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO:
    case TYPE_CONTENT_VIDEO_YOGA:
    case TYPE_CONTENT_VIDEO_FITNESS:
    case TYPE_CONTENT_VIDEO_MEDITATION:
      return true
    default:
      return false
  }
}

export function isTypeEpisode (type) {
  switch (type) {
    case TYPE_CONTENT_EPISODE:
    case TYPE_CONTENT_SEGMENT:
      return true
    default:
      return false
  }
}

export function isTypeYogaFitnessEpisode (type) {
  switch (type) {
    case TYPE_CONTENT_EPISODE_YOGA:
    case TYPE_CONTENT_EPISODE_FITNESS:
    case TYPE_CONTENT_EPISODE_MEDITATION:
    case TYPE_CONTENT_SEGMENT_YOGA:
    case TYPE_CONTENT_SEGMENT_FITNESS:
    case TYPE_CONTENT_SEGMENT_MEDITATION:
      return true
    default:
      return false
  }
}

export function isTypeYogaEpisode (type) {
  switch (type) {
    case TYPE_CONTENT_EPISODE_YOGA:
    case TYPE_CONTENT_SEGMENT_YOGA:
      return true
    default:
      return false
  }
}

export function isTypeMeditationEpisode (type) {
  switch (type) {
    case TYPE_CONTENT_EPISODE_MEDITATION:
    case TYPE_CONTENT_SEGMENT_MEDITATION:
      return true
    default:
      return false
  }
}

export function isTypeFitnessEpisode (type) {
  switch (type) {
    case TYPE_CONTENT_SEGMENT_FITNESS:
    case TYPE_CONTENT_EPISODE_FITNESS:
      return true
    default:
      return false
  }
}

export function isTypeEpisodeAll (type) {
  switch (type) {
    case TYPE_CONTENT_EPISODE:
    case TYPE_CONTENT_SEGMENT:
    case TYPE_CONTENT_EPISODE_YOGA:
    case TYPE_CONTENT_EPISODE_FITNESS:
    case TYPE_CONTENT_EPISODE_MEDITATION:
    case TYPE_CONTENT_SEGMENT_YOGA:
    case TYPE_CONTENT_SEGMENT_FITNESS:
    case TYPE_CONTENT_SEGMENT_MEDITATION:
      return true
    default:
      return false
  }
}

export function isYogaVideo (type) {
  switch (type) {
    case TYPE_CONTENT_VIDEO_YOGA:
      return true
    default:
      return false
  }
}

export function isTypeSeries (type) {
  switch (type) {
    case TYPE_CONTENT_SERIES:
      return true
    default:
      return false
  }
}

export function isTypeSeriesAll (type) {
  switch (type) {
    case TYPE_CONTENT_SERIES:
    case TYPE_CONTENT_SERIES_YOGA:
    case TYPE_CONTENT_SERIES_FITNESS:
    case TYPE_CONTENT_SERIES_MEDITATION:
    case TYPE_CONTENT_SEGMENTED:
    case TYPE_CONTENT_SEGMENTED_YOGA:
    case TYPE_CONTENT_SEGMENTED_FITNESS:
    case TYPE_CONTENT_SEGMENTED_MEDITATION:
      return true
    default:
      return false
  }
}

export function isTypeYogaFitnessSeries (type) {
  switch (type) {
    case TYPE_CONTENT_SERIES_YOGA:
    case TYPE_CONTENT_SERIES_FITNESS:
    case TYPE_CONTENT_SERIES_MEDITATION:
    case TYPE_CONTENT_SEGMENTED:
    case TYPE_CONTENT_SEGMENTED_YOGA:
    case TYPE_CONTENT_SEGMENTED_FITNESS:
    case TYPE_CONTENT_SEGMENTED_MEDITATION:
      return true
    default:
      return false
  }
}

/**
 * Checking if nodeData is a guide
 * @param {Map} nodeData
 * @returns {boolean}
 */
export function isGuideType (nodeData) {
  return nodeData.get('contentSubtype') === SUBTYPE_CONTENT_GUIDE
    || nodeData.get('displayType') === TYPE_DISPLAY_GUIDE
}

/**
 * Checking if nodeData is an event
 * @param {Map} nodeData
 * @returns {boolean}
 */
export function isEventType (nodeData) {
  return nodeData.get('contentSubtype') === SUBTYPE_CONTENT_EVENT
    || nodeData.get('displayType') === TYPE_DISPLAY_EVENT
}

/**
 * Get the base content type from the given contentType
 * @param {string} contentType
 * @returns {string}
 */
export function getBaseContentType (contentType) {
  // episode is not an actual content type, it is a derived content type from video
  if (contentType === TYPE_CONTENT_EPISODE) {
    return TYPE_CONTENT_VIDEO
  }

  if (contentType === TYPE_CONTENT_EPISODE_GUIDE) {
    return TYPE_CONTENT_VIDEO
  }

  if (contentType === TYPE_CONTENT_SERIES_GUIDE) {
    return TYPE_CONTENT_SERIES
  }

  return contentType
}
